import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";

//Helper functions
import { getSettings, notifyError, notifySuccess } from '../../../settings/Helpers';

//API
import api from '../../../settings/AxiosSetup';

//3rd party
import * as Icon from 'react-bootstrap-icons';
import toast, { Toaster } from 'react-hot-toast';
import 'moment/locale/nl';
import moment from 'moment';
import 'moment-timezone';
import Skeleton from 'react-loading-skeleton';
import Rodal from 'rodal';

//Components
import SideNav from '../../../components/sidenav/sidenav';
import BottomNav from '../../../components/bottomnav/bottomnav';
import DashboardHeader from '../../../components/dashboard/header';

//Assets
import svzArtwork from '../../../assets/images/artwork-svz.svg';
import svzArrowRight from '../../../assets/images/arrow-right-dark.svg';

//styles
import './evenementen.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-tooltip/dist/react-tooltip.css';
import 'rsuite/dist/rsuite-no-reset.min.css';
import 'rodal/lib/rodal.css';


const Evenementen = () => {

    //Set variables
    const navigate = useNavigate();
    const environment = process.env.REACT_APP_APP_URL;
    const loggedIn = localStorage.getItem('ingelogd');
    const medewerker = JSON.parse(localStorage.getItem('medewerker'));
    const [events, setEvents] = useState([]);
    const [userPoints, setUserPoints] = useState(0);
    const [showModalSuggestion, setShowModalSuggestion] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [formContent, setFormContent] = useState({
        title: '',
        date: '',
        price: 0,
        location: '',
        minimum_persons: 0,
        description: '',
        for_everyone: true,
        for_who: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    //Function to get evenementen
    const getEvenementen = async () => {
        try {
            const response = await api.get('/evenementen');
            if (response.data) {
                setUserPoints(response.data.medewerker_punten);
                let events = response.data.events ? [...response.data.events] : [];
                const newItem = {
                    id: 'custom-suggestion',
                    type: 'suggestion',
                    title: 'Heb je zelf een suggestie voor een leuk evenement?'
                };
                const insertIndex = events.length === 0 ? 0 : 1;
                events.splice(insertIndex, 0, newItem);
                setEvents(events);
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const submitEvent = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        try {
            const response = await api.post('/evenementen/aanvragen', {
                data: formContent
            });
            if (response.data) {
                setIsSubmitted(true);
                setFormContent({
                    title: '',
                    date: '',
                    price: 0,
                    location: '',
                    minimum_persons: 0,
                    description: '',
                    for_everyone: true,
                    for_who: ''
                });
            }
            setIsSubmitting(false);
        } catch (error) {
            console.log(error);
            setIsSubmitting(false);
        }
    }


    //Check if user is authenticated, else redirect to login
    useEffect(() => {
        //Get settings and check for maintenance
        const settings = getSettings();
        settings.then((result) => {
            if (result.onderhoudsmodus) {
                navigate('/onderhoud');
            }
        });
        if (loggedIn !== 'true') {
            navigate('/login');
        }
        getEvenementen();
    }, []);
    
    return (
    <div id="main" className="dashboard">
        {
            medewerker ?
            <SideNav page="/evenementen" />
            :
            null
        }
        
        <div className="dashboard-content">
            <DashboardHeader title="Evenementen" subtitle={'Mijn saldo: ' + userPoints + ' punten'} />
            {
                isLoading ?
                <div className="events-loaders">
                    <div className="event-loader"><Skeleton height={500} style={{marginBottom:25}} /></div>
                    <div className="event-loader"><Skeleton height={500} style={{marginBottom:25}} /></div>
                    <div className="event-loader"><Skeleton height={500} style={{marginBottom:25}} /></div>
                </div>
                :
                <div className="events">
                {
                    events.length > 0 ?
                    <>
                    {
                        events.map((item, index) =>  {
                            if (item.type && item.type === 'suggestion') {
                                return <div className="event suggestion" key={index}>
                                    <div className="suggestion-content">
                                        <Icon.CalendarRange color={'#1D252C'} size={28} />
                                        <h2>{item.title}</h2>
                                        <button onClick={() => setShowModalSuggestion(true)}>Klik hier</button>
                                    </div>
                                    <img src={svzArrowRight} className="arrow-right" />
                                </div>
                            } else {
                                return <div className="event" key={index}>
                                    <div className="event-header">
                                        <img src={environment + '' + item.afbeelding.url} className="event-image" />
                                        <div className="event-points">
                                            <div className="points"><p>{item.punten}</p><span>Punten</span></div>
                                            {item.eigen_bijdrage ? <div className="extra-money"><p>€ {item.eigen_bijdrage}</p><span>Eigen bijdrage</span></div> : null}
                                        </div>
                                    </div>
                                    <div className="event-meta">
                                        <h2>{item.naam}</h2>
                                        <div className="event-meta-content">
                                            <div className="event-meta-item">
                                                <Icon.GeoAlt color={'#e10514'} />
                                                <p>{item.locatie}</p>
                                            </div>
                                            <div className="event-meta-item">
                                                <Icon.Calendar color={'#e10514'} />
                                                <p>{moment(item.datum).format('DD-MM-YYYY')}</p>
                                            </div>
                                            <div className="event-meta-item">
                                                <Icon.PeopleFill color={'#e10514'} />
                                                <p>{item.aantal_plekken} plekken</p>
                                            </div>
                                        </div>
                                        <a href={'/evenementen/' + item.id}>Lees verder</a>
                                    </div>
                                </div>
                            }
                        })
                    }
                    </>
                    :
                    null
                }
                </div>
            }
            <Rodal visible={showModalSuggestion} onClose={() => { setShowModalSuggestion(false); setIsSubmitted(false); }} width={700} enterAnimation="slideDown" leaveAnimation="slideUp" closeOnEsc={true}>
                <h3>{isSubmitted ? 'Bedankt voor je aanvraag' : 'Idee voor een activiteit?'}</h3>
                {
                    isSubmitted ?
                    <>
                        <p>Je aanvraag is ontvangen en wij nemen binnen enkele werkdagen contact met je op.</p>
                        <p>Heb je in de tussentijd vragen bel dan even naar 0228 - 58 78 37 of mail naar marketing@svztransport.nl</p>
                        <p>Met vriendelijke groet,<br/>SVZ Transport</p>
                    </>
                    :
                    <form id="suggestion-form" onSubmit={submitEvent}>
                        <div className="field">
                            <label>Soort activiteit*</label>
                            <input type="text" className="form-field" placeholder="Titel" value={formContent.title} onChange={(e) => setFormContent({...formContent, title: e.target.value})} required />
                        </div>
                        <div className="field">
                            <label>Datum activiteit*</label>
                            <input type="date" className="form-field" placeholder="dd-mm-jjjj" value={formContent.date} onChange={(e) => setFormContent({...formContent, date: e.target.value})} required />
                        </div>
                        <div className="field">
                            <label>Prijs per persoon (optioneel)</label>
                            <input type="number" className="form-field" placeholder="€" value={formContent.price} onChange={(e) => setFormContent({...formContent, price: e.target.value})} />
                        </div>
                        <div className="field">
                            <label>Locatie/adres activiteit*</label>
                            <input type="text" className="form-field" placeholder="Locatie" value={formContent.location} onChange={(e) => setFormContent({...formContent, location: e.target.value})} required />
                        </div>
                        <div className="field">
                            <label>Minimum aantal personen*</label>
                            <input type="number" className="form-field" placeholder="Aantal personen" value={formContent.minimum_persons} onChange={(e) => setFormContent({...formContent, minimum_persons: e.target.value})} required />
                        </div>
                        <div className="field">
                            <label>Beschrijving van activiteit*</label>
                            <textarea placeholder="Beschrijving" className="form-field" value={formContent.description} onChange={(e) => setFormContent({...formContent, description: e.target.value})} required />
                        </div>
                        <div className="field">
                            <input type="checkbox" id="for-everyone" defaultChecked={formContent.for_everyone} checked={formContent.for_everyone} onChange={(e) => setFormContent({...formContent, for_everyone: e.target.checked})} />
                            <label htmlFor="for-everyone">Dit evenement is voor iedereen</label>
                        </div>
                        {
                            formContent.for_everyone ?
                            null
                            :
                            <div className="field">
                                <label>Voor wie* (indien niet voor iedereen)</label>
                                <textarea placeholder="Namen en/of specifieke afdeling" className="form-field" value={formContent.for_who} onChange={(e) => setFormContent({...formContent, for_who: e.target.value})} required />
                            </div>
                        }
                        <div className="form-footer">
                            <button className="button green" type="submit" disabled={isSubmitting}>Aanvraag versturen</button>
                        </div>
                    </form>
                }
            </Rodal>
            <Toaster />
        </div>
        {
            medewerker ?
            <BottomNav page="/evenementen" />
            :
            null
        }
    <img src={svzArtwork} className="artwork" />    
    </div>
    );
};
export default Evenementen;